import { RestPaginatedValues, RestSingleOptionOfContext } from 'generated-common/model/model';
import { CustomFieldType } from '../../model/model';

export const fieldEditor_showEditChildOptionButton = (parentOptionId: string | null, _optionId: string | undefined, fieldType: CustomFieldType): boolean => {
  if (fieldType === CustomFieldType.CASCADINGSELECT) {
    // Only show edit child options button on root parent options
    return parentOptionId === null;
  } else if (fieldType === CustomFieldType.SOURCESENSEMULTILEVELCASCADING) {
    // Always show edit child options button on any parent options
    return true;
  } else {
    // All other field types
    return false;
  }
};

export const getLastOptionIdOrNull = (ids: string[] | null) => {
  if (!ids || ids.length === 0) {
    return null;
  }
  return ids[ids.length - 1];
};

export const listContainsAtLeastOneOption = (options: RestPaginatedValues<RestSingleOptionOfContext> | null) => {
  return options && options.values && options.values.length > 0;
};

export const isTopLevelOfFieldEditor = (parentOptions: string[] | null) => {
  return parentOptions === null || parentOptions.length === 0;
};
